module.exports = __webpack_public_path__ + "static/media/iconeBoleto.d9af0f60.svg";